
<script setup>

import alertUrl from 'url:../../images/icons/alert.svg'

const { metric } = defineProps( [ 'metric' ] )

const { icon, statistic } = metric

</script>

<template>

  <div class="@container border-[1.5px] border-blue-fresh bg-black/15 px-5 flex justify-between items-center rounded-md">

    <div class="flex gap-2 @xs:gap-4 items-center py-5 ">

      <img :src="icon" :alt="statistic + 'icon'" class="h-11 w-11 hidden @2xs:block" v-if="!metric.alert"/>

      <img :src="alertUrl" class="h-11 w-11 hidden @2xs:block" v-else />

      <p class="max-w-24 font-bold capitalize">{{ statistic }}</p>

    </div>

    <div class="flex flex-col gap-1 py-3 sm:py-0">

      <div v-if="metric.localValue" class="flex gap-1 items-center justify-end">

        <span class="font-bold text-2xl sm:text-3xl lg:text-4xl">
          
          {{ metric.localValue }}&percnt;
          
        </span>
        
        <p class="text-xs max-w-13 @2xs:text-sm @2xs:max-w-16 leading-4 text-end">of county residents</p>

      </div>

      <div v-else class="flex items-center justify-end">

        <span class="font-bold text-2xl sm:text-3xl lg:text-4xl">N/A</span>

      </div>
      
      <div>

        <p class="text-white/50 text-xs sm:text-sm italic text-end">

          {{ metric.nationalValue }}&percnt; national average

        </p>

      </div>
        
    </div>

  </div>

</template>